/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 平台模块
 */

import { Notice } from "view-design"

export const MyWebSocket = function (option) {
    var that = this;
    that.option = option;
    that.OffFlag = false; // 是否手动关闭的标识 true手动关闭 false非手动关闭
    that.timer = null;
    that.siteMn = option.siteMn;
    that.callList = {};
    that.parkInfo = option.parkInfo;
}

MyWebSocket.prototype.register = function (topic, callBack) {
    var taht = this;
    taht.callList[topic] = callBack;
}

MyWebSocket.prototype.recontent = function () {
    var that = this;
    var option = that.option;
    var websocket = new WebSocket(option.url);

    websocket.onopen = function () {
        that.timer = setInterval(() => {
            websocket.send(1);
        }, 1000);
        option.onopen.call(that);
    };
    websocket.onmessage = function (res) {
        let data = JSON.parse(res.data);
        if (data.code == 200) {
            var tempCall = that.callList[data.topic];
            if (typeof tempCall === "function") {
                tempCall(data);
            }
        } else {
            Notice.error({
                title: "获取信息失败",
                desc: "请联系管理员"
            })
        }
    };
    websocket.onclose = function (err) {

        if (that.timer) {
            clearInterval(that.timer);
        }
        if (!that.OffFlag) { // 若非手动关闭 在再次建立连接
            setTimeout(() => {
                that.recontent();
            }, 1000)
        }
    };
    that._websocket = websocket;
}

MyWebSocket.prototype.send = function (instruction, topic) {
    var data = JSON.stringify({
        instruction: instruction,
        topic: JSON.stringify(topic),
        parkId: this.parkInfo ? this.parkInfo.id + "" : null
    });
    this._websocket.send(data);
}

MyWebSocket.prototype.close = function () {
    this.OffFlag = true;
    this._websocket.close();
}